import type { components, paths } from "./types.gen";
import { apiFetch } from "./client";

export type Project = components["schemas"]["Project"];
export type ProjectWithLatestScan = components["schemas"]["ProjectWithLatestScan"];

type ListResponse = paths["/api/projects"]["get"]["responses"]["200"]["content"]["application/json"];
type GetResponse = paths["/api/projects/{id}"]["get"]["responses"]["200"]["content"]["application/json"];
type CreateBody = paths["/api/projects"]["post"]["requestBody"]["content"]["application/json"];
type CreateResponse = paths["/api/projects"]["post"]["responses"]["201"]["content"]["application/json"];
type UpdateBody = paths["/api/projects/{id}"]["patch"]["requestBody"]["content"]["application/json"];
type UpdateResponse = paths["/api/projects/{id}"]["patch"]["responses"]["200"]["content"]["application/json"];
type RegenerateResponse = paths["/api/projects/{id}/regenerate-key"]["post"]["responses"]["200"]["content"]["application/json"];
type SeedUrlListResponse = paths["/api/projects/{id}/seed-urls"]["get"]["responses"]["200"]["content"]["application/json"];
type AddSeedUrlsBody = paths["/api/projects/{id}/seed-urls"]["post"]["requestBody"]["content"]["application/json"];
type AddSeedUrlsResponse = paths["/api/projects/{id}/seed-urls"]["post"]["responses"]["200"]["content"]["application/json"];

export type SeedUrl = components["schemas"]["SeedUrl"];

export const projectsApi = {

    async list(params: { page?: number; per_page?: number } = {}): Promise<ListResponse> {

        const search = new URLSearchParams();
        if (params.page) search.set("page", String(params.page));
        if (params.per_page) search.set("per_page", String(params.per_page));
        const qs = search.toString();
        return apiFetch<ListResponse>(`/api/projects${qs ? `?${qs}` : ""}`);
    },

    async get(id: string): Promise<Project> {

        const res = await apiFetch<GetResponse>(`/api/projects/${id}`);
        return res.data;
    },

    create(body: CreateBody): Promise<CreateResponse> {

        return apiFetch<CreateResponse>("/api/projects", { method: "POST", json: body });
    },

    async update(id: string, body: UpdateBody): Promise<Project> {

        const res = await apiFetch<UpdateResponse>(`/api/projects/${id}`, { method: "PATCH", json: body });
        return res.data;
    },

    delete(id: string): Promise<void> {

        return apiFetch<void>(`/api/projects/${id}`, { method: "DELETE", json: { confirm: true } });
    },

    regenerateKey(id: string): Promise<RegenerateResponse> {

        return apiFetch<RegenerateResponse>(`/api/projects/${id}/regenerate-key`, { method: "POST" });
    },

    async listSeedUrls(projectId: string): Promise<SeedUrl[]> {

        const res = await apiFetch<SeedUrlListResponse>(`/api/projects/${projectId}/seed-urls`);
        return res.data;
    },

    async addSeedUrls(projectId: string, urls: string[]): Promise<AddSeedUrlsResponse["data"]> {

        const body: AddSeedUrlsBody = { urls };
        const res = await apiFetch<AddSeedUrlsResponse>(`/api/projects/${projectId}/seed-urls`, {
            method: "POST",
            json: body,
        });
        return res.data;
    },

    deleteSeedUrl(projectId: string, seedId: string): Promise<void> {

        return apiFetch<void>(`/api/projects/${projectId}/seed-urls/${seedId}`, { method: "DELETE" });
    },
};
